var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheckmarkCompare = function SvgCheckmarkCompare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 23 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#181818",
    strokeWidth: 3,
    d: "M2 9.636 8.333 16 21 2"
  })));
};
export { SvgCheckmarkCompare as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjMgMTkiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPHBhdGggZD0iTTIgOS42MzYgOC4zMzMgMTYgMjEgMiIgc3Ryb2tlPSIjMTgxODE4IiBzdHJva2Utd2lkdGg9IjMiLz4KPC9zdmc+";